import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { Section, SectionHeading, CTAButton } from './shared';
const feeItems = [{
  term: 'Free first discussion',
  body: 'Start with a confidential conversation about what happened and whether we may be able to help.'
}, {
  term: 'No win, no fee',
  body: 'Legal fees are paid at the end of a successful claim, subject to the written agreement.'
}, {
  term: 'Claim costs funded while it runs',
  body: 'Approved medical report fees, filing fees and claim disbursements are funded during the matter.'
}, {
  term: 'Everything explained before you decide',
  body: 'You receive the fee arrangement and important risks in writing, with time to ask questions.'
}];
export function FeesExplained() {
  return <Section id="fees" className="bg-canvas" data-id="element-222" data-mp="aa5kaxl08im2">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.78fr_1.22fr] lg:gap-12" data-id="element-223" data-mp="abgjsl7f347d">
        <div data-id="element-224" data-mp="f98m895ou8pt">
          <SectionHeading eyebrow="Costs & fees" title="Clear Costs. No Upfront Legal Fees." intro="Cost should not stop you asking whether you have a claim. We explain the arrangement before you make any commitment." data-id="element-225" data-mp="fat694udm99f" />
          <CTAButton href="#compensation-calculator" className="mt-7" data-id="element-226" data-mp="1aidot3o3b1fy">
            Start free claim check
          </CTAButton>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-227" data-mp="15gel1sofu2ih">
          {feeItems.map(item => <article key={item.term} className="flex h-full gap-3 rounded-card border border-ink/5 bg-paper p-5 shadow-card" data-id="element-228" data-mp="2265pokqg1620">
              <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-forest" aria-hidden="true" data-id="element-229" data-mp="1t68vk3labezk" />
              <div data-id="element-230" data-mp="hsdid0dxxgaz">
                <h3 className="text-[18px] font-semibold leading-[1.3] text-ink" data-id="element-231" data-mp="hsx0oi7i66pj">
                  {item.term}
                </h3>
                <p className="mt-2 text-[15px] leading-[1.55] text-slate" data-id="element-232" data-mp="crzapjg948dh">
                  {item.body}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </Section>;
}